import React, { useEffect, useState } from "react";
import { alertify, handleApiExceptions } from "../../app_methods";
import { Button, Form, Icon, Input, Select, Spin, Switch, Tooltip } from "antd";
import { Text1 } from "../../styles";
import { WebhookConfigurationModel } from "../../models/webhook_configuration";
import { EaseTable } from "../../libs/EaseTable";
import { WebhookDrawerWrapper } from "./styles";
import { ErrorModal } from '../Common/BulkUploadModal/error_modal';
import { CopyThat } from "../Common";

let WebhookDrawer = (props) => {
  const { width, visible, form, toggleWebhookConfigModal, isInsta = false } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isTesting, setIsTesting] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [configData, setConfigData] = useState([]);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState([]);


  const { getFieldValue } = form;

  useEffect(() => {
    if (visible) {
      fetchConfigurations();
    }
  }, [visible]);

  const fetchConfigurations = async (_pagination) => {
    setIsLoading(true);
    const response = await WebhookConfigurationModel.getWebhookConfiguration(isInsta);

    if (!response.success) {
      handleApiExceptions(response);
      setIsLoading(false);
      return;
    }
    setConfigData(response?.data?.webhook_settings || []);
    setIsLoading(false);
  };

  const testWebhook = async (event, url) => {
    setIsTesting(event);
    const response = await WebhookConfigurationModel.testWebhook(isInsta, { event_name: event, url: url });

    if (!response.success) {
      handleApiExceptions(response);
      setIsTesting('');
      return;
    }
    alertify("Success!", "Test Webhook sent successfully.", "success")
    setIsTesting('');
  }
  const handleSubmit = () => {
    form.validateFields(async (err, values) => {
      if (err) return
      setIsSubmitting(true);
      const response = await WebhookConfigurationModel.postWebhookConfiguration(isInsta, { webhook_settings: values });
      if (!response.success) {
        setIsSubmitting(false);
        if (typeof (response.message) == "string") {
          handleApiExceptions(response.message);
          return;
        }
        if (response.message) {
          setValidationErrors([response.message.error]);
          toggleErrorModal();
          return;
        }
        handleApiExceptions(response);
        return;
      }

      toggleWebhookConfigModal()
      alertify("Success!", "Webhook Settings saved successfully.", "success");
      setIsSubmitting(false);
    });
  };

  const toggleErrorModal = () => {
    setShowErrorModal(!showErrorModal);
  };

  const getColumns = (actions) => {
    const { form } = actions;
    const { getFieldDecorator } = form;
    const validations = WebhookConfigurationModel.validations;

    return [
      {
        title: <p className="mb-0 ml-2">Status</p>,
        key: "status",
        width: 100,
        render: (record, _val, index) => {
          return (
            <Form.Item className="mt-3">
              {getFieldDecorator(`[${record.event_name}]['is_enable']`, {
                initialValue: record?.is_enable || false,
                valuePropName: "checked",
              })(<Switch className="ml-2" />)}
            </Form.Item>
          );
        },
      },
      {
        title: "Trigger Event",
        key: "event_name",
        width: 260,
        render: (record, _val) =>
          <>
            <span>{record.event_label}</span>
            {record.webhook_note &&
              <Tooltip
                title={record.webhook_note}
                className="mr-1"
                onClick={(e) => e.preventDefault()}
              >
                <Icon style={{ fontSize: 14, marginTop: "3px" }} className="ml-1" type="info-circle" />
              </Tooltip>
            }
          </>,
      },
      {
        title: "Webhook URL ",
        key: "webhook_url",
        width: "300px",
        render: (record, _val, index) => {
          return (
            <div className="mt-3 d-flex align-items-center ">
              <Form.Item className="">
                {getFieldDecorator(`[${record.event_name}]['url']`, {
                  initialValue: record?.url ?? "",
                  rules: validations.webhook_url(getFieldValue(`[${record.event_name}]['is_enable']`)),
                  disabled: !getFieldValue(`[${record.event_name}]['is_enable']`),
                })(
                  <Input
                    style={{ width: "280px" }}
                    autoComplete="off"
                    disabled={!getFieldValue(`[${record.event_name}]['is_enable']`)}
                  />
                )}
              </Form.Item>
              <CopyThat
                onlyIcon={true}
                copyText={getFieldValue(`[${record.event_name}]['url']`)}
                className="mb-4 ml-2"
              />
            </div>
          );
        },
      },
      {
        title: "Automatic Retrigger Attempts ",
        key: "max_attempts",
        width: "180px",
        render: (record, _val, index) => (
          <Form.Item className="mt-3">
            {getFieldDecorator(`[${record.event_name}]['max_attempts']`, {
              initialValue: record?.max_attempts ?? "",
              disabled: !getFieldValue(`[${record.event_name}]['is_enable']`),
              rules: validations.max_attempts(getFieldValue(`[${record.event_name}]['is_enable']`) && (getFieldValue(`[${record.event_name}]['interval_value']`) || getFieldValue(`[${record.event_name}]['interval_unit']`))),
            })(<Input autoComplete="off" disabled={!getFieldValue(`[${record.event_name}]['is_enable']`)} />)}
          </Form.Item>
        ),
      },
      {
        title: "Automatic Retrigger Interval ",
        key: "trigger_interval_unit",
        width: "180px",
        render: (record, _val, index) => (
          <Form.Item className="mt-4">
            {getFieldDecorator(`[${record.event_name}]['interval_value']`, {
              initialValue: record?.interval_value ?? "",
              disabled: !getFieldValue(`[${record.event_name}]['is_enable']`),
              rules: validations.interval_value(getFieldValue(`[${record.event_name}]['is_enable']`) && getFieldValue(`[${record.event_name}]['max_attempts']`), getFieldValue(`[${record.event_name}]['interval_unit']`))
            })(
              <Input
                style={{ width: "100%" }}
                autoComplete="off"
                disabled={!getFieldValue(`[${record.event_name}]['is_enable']`)}
                addonAfter={
                  <>
                    {getFieldDecorator(`[${record.event_name}]['interval_unit']`, {
                      initialValue: record?.interval_unit || "",
                      disabled: !getFieldValue(`[${record.event_name}]['is_enable']`),
                      rules: validations.interval_unit(getFieldValue(`[${record.event_name}]['is_enable']`) && getFieldValue(`[${record.event_name}]['interval_value']`)),
                    })(
                      <Select style={{ width: "90px" }} allowClear={true} disabled={!getFieldValue(`[${record.event_name}]['is_enable']`)}>
                        <Select.Option value="minutes">Minutes</Select.Option>
                        <Select.Option value="hours">Hours</Select.Option>
                      </Select>
                    )}
                  </>
                }
              />
            )}
          </Form.Item>
        ),
      },
      {
        title: "Actions",
        width: "100px",
        render: (record, _val) => {
          return (
            <div className="mb-2">
              <Button
                loading={isTesting == record.event_name}
                onClick={() => testWebhook(record.event_name, getFieldValue(`[${record.event_name}]['url']`))}
                disabled={!(getFieldValue(`[${record.event_name}]['is_enable']`) && getFieldValue(`[${record.event_name}]['url']`)) || (form.getFieldError(`[${record.event_name}]['url']`)?.length > 0) }
              >
                Test
              </Button>
            </div>
          );
        },
      },
    ];
  };


  return (
    <WebhookDrawerWrapper
      className="webhook-wrapper"
      visible={visible}
      title={<Text1>Webhook Configuration</Text1>}
      onClose={() => toggleWebhookConfigModal()}
      width={width}
      hideBackArrow={true}
      hideFooter={true}
      destroyOnClose
    >
      <Spin style={{ height: "100%" }} spinning={isLoading}>
        <div className="d-flex flex-column h-100 justify-content-between">
          <EaseTable className="mt-1" rowKey="id" data={configData} columns={getColumns({ form })} scrollY={750} />
          <div
            className="d-flex justify-content-end"
            style={{
              marginBottom: "20px",
            }}
          >
            <Button type="primary mb-2" size="large" className="px-5" onClick={handleSubmit} loading={isSubmitting}>
              Save
            </Button>
          </div>
        </div>
      </Spin>
      <ErrorModal
        visible={showErrorModal}
        toggleErrorModal={toggleErrorModal}
        errors={validationErrors}
        alert_message="Consult the following errors, fix your config and save again."
      />
    </WebhookDrawerWrapper>


  );
};

WebhookDrawer = Form.create({
  onFieldsChange: (props, fields, allFields) => {
    const { form } = props;
    const keys = Object.keys(fields)[0];
    if (fields[keys]?.hasOwnProperty("is_enable") && !fields[keys]?.is_enable?.value) {
      form.setFieldsValue({ [`[${keys}]['url']`]: allFields[keys]?.url?.value });
      form.setFieldsValue({ [`[${keys}]['max_attempts']`]: allFields[keys]?.max_attempts?.value });
      form.setFieldsValue({ [`[${keys}]['interval_value']`]: allFields[keys]?.interval_value?.value });
      form.setFieldsValue({ [`[${keys}]['interval_unit']`]: allFields[keys]?.interval_unit?.value });
    }
  },
})(WebhookDrawer);

export { WebhookDrawer };
